import { render, staticRenderFns } from "./Students.html?vue&type=template&id=74d82ff3&external"
import script from "./Students.js?vue&type=script&lang=js&external"
export * from "./Students.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports